// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image2-space1-qcNEW {
	margin-bottom: 6px !important;
}

.Image2-space2-ow8m4 {
	margin-bottom: 12px !important;
}

.Image2-space3-V75O9 {
	margin-bottom: 18px !important;
}

.Image2-space4-Lqy5H {
	margin-bottom: 24px !important;
}

.Image2-space5-nBRQl {
	margin-bottom: 30px !important;
}

.Image2-space6-mmw2Z {
	margin-bottom: 36px !important;
}

.Image2-space7-W0Hzc {
	margin-bottom: 42px !important;
}

.Image2-spaceTop8-IlZyo {
	margin-bottom: 48px !important;
}

.Image2-spaceTop1-IayWB {
	margin-top: 6px !important;
}

.Image2-spaceTop2-a6pwZ {
	margin-top: 12px !important;
}

.Image2-spaceTop3-kqZAO {
	margin-top: 18px !important;
}

.Image2-spaceTop4-VxlST {
	margin-top: 24px !important;
}

.Image2-spaceTop5-JQy5n {
	margin-top: 30px !important;
}

.Image2-spaceTop6-UtWBW {
	margin-top: 36px !important;
}

.Image2-spaceTop7-TXBVw {
	margin-top: 42px !important;
}

.Image2-spaceTop8-IlZyo {
	margin-top: 48px !important;
}

.Image2-noMargin-WbN7t {
	margin: 0px !important;
}

.Image2-padding1-BLcYY {
	padding-bottom: 6px !important;
}

.Image2-padding2-DGpYN {
	padding-bottom: 12px !important;
}

.Image2-padding3-VS_ba {
	padding-bottom: 18px !important;
}

.Image2-padding4-FXDkk {
	padding-bottom: 24px !important;
}

.Image2-padding5-sIqle {
	padding-bottom: 30px !important;
}

.Image2-padding6-elqte {
	padding-bottom: 36px !important;
}

.Image2-padding7-UFMge {
	padding-bottom: 42px !important;
}

.Image2-paddingTop1-MgsuK {
	padding-top: 6px !important;
}

.Image2-paddingTop2-IGQMZ {
	padding-top: 12px !important;
}

.Image2-paddingTop3-MJGFX {
	padding-top: 18px !important;
}

.Image2-paddingTop4-CqzLc {
	padding-top: 24px !important;
}

.Image2-paddingTop5-ZXii2 {
	padding-top: 30px !important;
}

.Image2-paddingTop6-iVPth {
	padding-top: 36px !important;
}

.Image2-paddingTop7-HKHIo {
	padding-top: 42px !important;
}

.Image2-noPadding-_WLZ3 {
	padding: 0px !important;
}

.Image2-textBold-JFrOR {
	font-weight: 500 !important;
}

.Image2-textBolder-k7fR8 {
	font-weight: 700 !important;
}

.Image2-textNormal-piPmf {
	font-weight: normal !important;
}

.Image2-spaceBottom20-V3El2 {
	margin-bottom: 20px;
}

.Image2-spaceBottom10-ga5qL {
	margin-bottom: 10px;
}

.Image2-marginNone-Pj64j {
	margin: 0;
}

.Image2-spaceBottom15-CbfCj {
	margin-bottom: 15px;
}

.Image2-marginTopNone-P6vH3 {
	margin-top: 0;
}

.Image2-spaceTop11-ceE8Q {
	margin-top: 11px;
}

.Image2-spaceTop21-A6AWZ {
	margin-top: 21px;
}

.Image2-spaceTop20-Xd3fn {
	margin-top: 20px;
}

.Image2-spaceTop10-RmKU5 {
	margin-top: 10px;
}

/*New Design Text Colors */

.Image2-textDarkBlue-Z2QVj {
	color: rgb(20, 39, 94) !important;
}

.Image2-textLightBlue-UzRn4 {
	color: rgb(57, 87, 106) !important;
}

.Image2-textLightSandleGreen-gXZ_l {
	color: rgb(76, 86, 41) !important;
}

.Image2-textLightBrown-iR5RR {
	color: rgb(115, 79, 33) !important;
}

.Image2-textMediumMaroon-foyMC {
	color: rgb(87, 37, 51) !important;
}

.Image2-textBrown-XmzPm {
	color: rgb(160, 47, 24) !important;
}

.Image2-textMaroon-GJoRk {
	color: rgb(155, 49, 67) !important;
}

.Image2-textDarkBrown-bs_b4 {
	color: rgb(83, 18, 16) !important;
}

.Image2-textMediumBrown-r_csC {
	color: rgb(142, 28, 10) !important;
}

.Image2-textSkyBlue-l8BJg {
	color: rgb(37, 117, 141) !important;
}

.Image2-textGray-p8Iai {
	color: rgb(77, 65, 51) !important;
}

.Image2-commonHeaderAdmin-FHe2P {
	position: fixed !important;
}

.Image2-adminLayout-oQ8t2 {
	padding-top: 64px !important;
}

.Image2-box-FIw0u h2 {
	font-size: 21px;
	font-weight: 600;
}

.Image2-exportLink-GPhtk {
	margin-bottom: -29px;
}

.Image2-blockCenter-CLLER {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Image2-panelHeader-Ot3RU {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Image2-currencyselect-QlPJd {
	width: 100%;
	margin-right: 0px;
}

.Image2-panelHeader-Ot3RU {
	overflow: hidden;
	position: relative;
}

.Image2-mar0-K3pKs {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Image2-blockCenter-CLLER {
		padding: 0px;
	}

	.Image2-panelHeader-Ot3RU {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Image2-sideAdminPageWrapper-JQQqN {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Image2-panelHeader-Ot3RU {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Image2-table-Q8Vyk {
	display: table;
}

.Image2-tableRow-UCH5j {
	display: table-row;
}

.Image2-tableCell-bMzYs {
	display: table-cell;
	float: none;
}

.Image2-formGroup-YpsdH {
	margin-bottom: 6px;
}

.Image2-select-UKez6 {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Image2-noMargin-WbN7t {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Image2-exportLink-GPhtk {
	padding-top: 10px;
	padding-right: 10px;
}

.Image2-labelTextNew-jwoc7 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image2-displayInline-PYuBB {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Image2-btnUPdate-l6FLr {
	display: inline-block;
}

.Image2-btnModalDelete-MYd3m {
	display: inline-block;
	margin-left: 15px;
}

.Image2-radioBtn-penj3 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Image2-backgroundImg-cH9uG {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Image2-btnUPdate-l6FLr {
		display: block;
		margin-bottom: 12px;
	}

	.Image2-btnModalDelete-MYd3m {
		display: block;
		margin-left: 0px;
	}

	.Image2-btnWidth-Iah_T {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Image2-bannerImageBg-RTUO3 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Image2-bannerDelete-R6vf1 {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Image2-modalRoot-ctDjw {
	padding: 32px;
}

.Image2-modalBorderBottom-U6b1J {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Image2-logInModalBody-Mczla {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Image2-exportSection-tBEXM {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Image2-exportSectionGridSub-HvKr3 {
	grid-template-columns: 50% 49% !important;
}

.Image2-exportText-LU6Xq {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Image2-exportLinkImg-WBCaR {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Image2-vtrMiddle-MaCw7 {
	vertical-align: middle;
}

.Image2-exportImg-Q4Abt {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Image2-profileViewlabel-q1szr {
	display: inline-block;
	width: 38%
}

.Image2-profileViewMainContent-GpsNS {
	display: inline-block;
	width: 62%;
}

.Image2-profileViewMain-J9oRG {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Image2-profileViewInner-TCElZ {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Image2-profileImageSection-BYp3W {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Image2-lastviewInner-H84dQ {
	padding: 10px;
}

.Image2-whyHostHoriLine-GNhqq {
	margin: 30px 0;
}

.Image2-tableGrid-EKWv1 {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Image2-headingContent-Z6edW {
	font-size: 18px;
	font-weight: 500;
}

.Image2-refundTextColor-MPTS6 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Image2-dividerLine-so65A {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Image2-smallContent-VubtX {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Image2-sideAdminPageWrapper-JQQqN {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Image2-sideAdminPageWrapper-JQQqN {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Image2-exportSection-tBEXM {
		grid-template-columns: 100%;
	}

	.Image2-exportSectionGridSub-HvKr3 {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Image2-profileViewlabel-q1szr {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Image2-profileViewMainContent-GpsNS {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Image2-ChangeToUpperCase-e0sEN {
	text-transform: uppercase
}

.Image2-noBorder-cX7_3 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Image2-siteAdminHeading-CGSEA {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image2-siteAdminSubHeading-KP8yA {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image2-adminFormDivider-MrrU6 {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Image2-space1-qcNEW`,
	"space2": `Image2-space2-ow8m4`,
	"space3": `Image2-space3-V75O9`,
	"space4": `Image2-space4-Lqy5H`,
	"space5": `Image2-space5-nBRQl`,
	"space6": `Image2-space6-mmw2Z`,
	"space7": `Image2-space7-W0Hzc`,
	"spaceTop8": `Image2-spaceTop8-IlZyo`,
	"spaceTop1": `Image2-spaceTop1-IayWB`,
	"spaceTop2": `Image2-spaceTop2-a6pwZ`,
	"spaceTop3": `Image2-spaceTop3-kqZAO`,
	"spaceTop4": `Image2-spaceTop4-VxlST`,
	"spaceTop5": `Image2-spaceTop5-JQy5n`,
	"spaceTop6": `Image2-spaceTop6-UtWBW`,
	"spaceTop7": `Image2-spaceTop7-TXBVw`,
	"noMargin": `Image2-noMargin-WbN7t`,
	"padding1": `Image2-padding1-BLcYY`,
	"padding2": `Image2-padding2-DGpYN`,
	"padding3": `Image2-padding3-VS_ba`,
	"padding4": `Image2-padding4-FXDkk`,
	"padding5": `Image2-padding5-sIqle`,
	"padding6": `Image2-padding6-elqte`,
	"padding7": `Image2-padding7-UFMge`,
	"paddingTop1": `Image2-paddingTop1-MgsuK`,
	"paddingTop2": `Image2-paddingTop2-IGQMZ`,
	"paddingTop3": `Image2-paddingTop3-MJGFX`,
	"paddingTop4": `Image2-paddingTop4-CqzLc`,
	"paddingTop5": `Image2-paddingTop5-ZXii2`,
	"paddingTop6": `Image2-paddingTop6-iVPth`,
	"paddingTop7": `Image2-paddingTop7-HKHIo`,
	"noPadding": `Image2-noPadding-_WLZ3`,
	"textBold": `Image2-textBold-JFrOR`,
	"textBolder": `Image2-textBolder-k7fR8`,
	"textNormal": `Image2-textNormal-piPmf`,
	"spaceBottom20": `Image2-spaceBottom20-V3El2`,
	"spaceBottom10": `Image2-spaceBottom10-ga5qL`,
	"marginNone": `Image2-marginNone-Pj64j`,
	"spaceBottom15": `Image2-spaceBottom15-CbfCj`,
	"marginTopNone": `Image2-marginTopNone-P6vH3`,
	"spaceTop11": `Image2-spaceTop11-ceE8Q`,
	"spaceTop21": `Image2-spaceTop21-A6AWZ`,
	"spaceTop20": `Image2-spaceTop20-Xd3fn`,
	"spaceTop10": `Image2-spaceTop10-RmKU5`,
	"textDarkBlue": `Image2-textDarkBlue-Z2QVj`,
	"textLightBlue": `Image2-textLightBlue-UzRn4`,
	"textLightSandleGreen": `Image2-textLightSandleGreen-gXZ_l`,
	"textLightBrown": `Image2-textLightBrown-iR5RR`,
	"textMediumMaroon": `Image2-textMediumMaroon-foyMC`,
	"textBrown": `Image2-textBrown-XmzPm`,
	"textMaroon": `Image2-textMaroon-GJoRk`,
	"textDarkBrown": `Image2-textDarkBrown-bs_b4`,
	"textMediumBrown": `Image2-textMediumBrown-r_csC`,
	"textSkyBlue": `Image2-textSkyBlue-l8BJg`,
	"textGray": `Image2-textGray-p8Iai`,
	"commonHeaderAdmin": `Image2-commonHeaderAdmin-FHe2P`,
	"adminLayout": `Image2-adminLayout-oQ8t2`,
	"box": `Image2-box-FIw0u`,
	"exportLink": `Image2-exportLink-GPhtk`,
	"blockCenter": `Image2-blockCenter-CLLER`,
	"panelHeader": `Image2-panelHeader-Ot3RU`,
	"currencyselect": `Image2-currencyselect-QlPJd`,
	"mar0": `Image2-mar0-K3pKs`,
	"sideAdminPageWrapper": `Image2-sideAdminPageWrapper-JQQqN`,
	"table": `Image2-table-Q8Vyk`,
	"tableRow": `Image2-tableRow-UCH5j`,
	"tableCell": `Image2-tableCell-bMzYs`,
	"formGroup": `Image2-formGroup-YpsdH`,
	"select": `Image2-select-UKez6`,
	"labelTextNew": `Image2-labelTextNew-jwoc7`,
	"displayInline": `Image2-displayInline-PYuBB`,
	"btnUPdate": `Image2-btnUPdate-l6FLr`,
	"btnModalDelete": `Image2-btnModalDelete-MYd3m`,
	"radioBtn": `Image2-radioBtn-penj3`,
	"backgroundImg": `Image2-backgroundImg-cH9uG`,
	"btnWidth": `Image2-btnWidth-Iah_T`,
	"bannerImageBg": `Image2-bannerImageBg-RTUO3`,
	"bannerDelete": `Image2-bannerDelete-R6vf1`,
	"modalRoot": `Image2-modalRoot-ctDjw`,
	"modalBorderBottom": `Image2-modalBorderBottom-U6b1J`,
	"logInModalBody": `Image2-logInModalBody-Mczla`,
	"exportSection": `Image2-exportSection-tBEXM`,
	"exportSectionGridSub": `Image2-exportSectionGridSub-HvKr3`,
	"exportText": `Image2-exportText-LU6Xq`,
	"exportLinkImg": `Image2-exportLinkImg-WBCaR`,
	"vtrMiddle": `Image2-vtrMiddle-MaCw7`,
	"exportImg": `Image2-exportImg-Q4Abt`,
	"profileViewlabel": `Image2-profileViewlabel-q1szr`,
	"profileViewMainContent": `Image2-profileViewMainContent-GpsNS`,
	"profileViewMain": `Image2-profileViewMain-J9oRG`,
	"profileViewInner": `Image2-profileViewInner-TCElZ`,
	"profileImageSection": `Image2-profileImageSection-BYp3W`,
	"lastviewInner": `Image2-lastviewInner-H84dQ`,
	"whyHostHoriLine": `Image2-whyHostHoriLine-GNhqq`,
	"tableGrid": `Image2-tableGrid-EKWv1`,
	"headingContent": `Image2-headingContent-Z6edW`,
	"refundTextColor": `Image2-refundTextColor-MPTS6`,
	"dividerLine": `Image2-dividerLine-so65A`,
	"smallContent": `Image2-smallContent-VubtX`,
	"ChangeToUpperCase": `Image2-ChangeToUpperCase-e0sEN`,
	"noBorder": `Image2-noBorder-cX7_3`,
	"siteAdminHeading": `Image2-siteAdminHeading-CGSEA`,
	"siteAdminSubHeading": `Image2-siteAdminSubHeading-KP8yA`,
	"adminFormDivider": `Image2-adminFormDivider-MrrU6`
};
module.exports = ___CSS_LOADER_EXPORT___;
